import { useLocales } from '@shared/locales'
import { Modal } from 'antd'

import { useState } from 'react'

import { ProductForm } from './ProductForm'
import { ActionsType } from './types'

const formName = 'add-edit-product-form'

type Props = {
  product?: ActionsType['product']
  opportunityData?: ActionsType['opportunityData']
  opportunityProducts?: ActionsType['opportunityProducts']
} & Omit<ActionsType, 'product' | 'opportunityData' | 'opportunityProducts'>

export const AddEditProduct = ({
  product,
  opportunityData,
  opportunityProducts,
  ...props
}: Props) => {
  const { t } = useLocales()
  const [isLoading, setIsLoading] = useState(false)

  return (
    <Modal
      width={700}
      maskClosable={false}
      title={
        product ? t('nomenclature.edit_product') : t('nomenclature.add_product')
      }
      cancelText={t('buttons.cancel')}
      okText={t('buttons.save')}
      okButtonProps={{
        htmlType: 'submit',
        form: formName,
        disabled: isLoading
      }}
      {...props}
    >
      <ProductForm
        id={product?.id}
        formName={formName}
        onCancel={props.onCancel}
        opportunityData={opportunityData}
        opportunityProducts={opportunityProducts}
        onLoadingChange={setIsLoading}
      />
    </Modal>
  )
}
